import { View } from "react-native"
import { Body, H3 } from "@/components/standard/BFText"

import { type ReactNode, useLayoutEffect } from "react"
import { setStatusBarOverride } from "@/stores/statusBarStyle"
import { cn } from "@/components/util/cn"
import FullScreenBackgroundGradient from "@/components/backgrounds/FullScreenBackgroundGradient"
import { Image } from "expo-image"

export default function FullScreenLoader({
  children,
  dark = false,
}: {
  children?: ReactNode
  dark?: boolean
}) {
  useLayoutEffect(() => {
    setStatusBarOverride("dark")
    return () => {
      setStatusBarOverride(null)
    }
  }, [])

  return (
    <View
      testID="full-screen-loader"
      className={cn([
        "flex flex-1 justify-center items-center bg-off-white p-6",
        dark ? "bg-midnight-blue" : "bg-off-white",
      ])}
    >
      {dark && <FullScreenBackgroundGradient />}
      <View className="flex">
        <View className="flex w-[200px]">
          <H3 color={dark ? "white" : "primary"} className="text-center">
            {children}
          </H3>
          <Body color={dark ? "white" : "primary"} className="text-center pt-2">
            This may take a few seconds
          </Body>
        </View>
        <View className="flex items-center justify-center">
          <Image
            source={
              dark
                ? require("@/assets/loading-animation_teal.gif")
                : require("@/assets/images/bouncing-balls.gif")
            }
            contentFit="contain"
            style={{ width: 129, height: 129, objectFit: "cover" }}
          />
        </View>
      </View>
    </View>
  )
}
